export const SM: Record<string, string> = {
  SM_COMPANY: 'SM_COMPANY',
  SM_CHAT_SUPPORT: 'SM_CHAT_SUPPORT',
  SM_DASHBOARD: 'SM_DASHBOARD',
  SM_FIELD: 'SM_FIELD',
  SM_MAP: 'SM_MAP',
  SM_FIELDACTIVITY: 'SM_FIELDACTIVITY',
  SM_SENSOR: 'SM_SENSOR',
  SM_WAREHOUSE: 'SM_WAREHOUSE',
  SM_PRODUCT: 'SM_PRODUCT',
  SM_LOAD: 'SM_LOAD',
  SM_SILOS: 'SM_SILOS',
  SM_EQUIPMENT: 'SM_EQUIPMENT',
  SM_NOTE: 'SM_NOTE',
  SM_SETTING: 'SM_SETTING',
  SM_GUIDE: 'SM_GUIDE',
  SM_BATCH: 'SM_BATCH',
  SM_ALERT: 'SM_ALERT',
  SM_WEATHER_FREE: 'SM_WEATHER_FREE',
  SM_SATELLITE_FREE: 'SM_SATELLITE_FREE',
  SM_SHOP: 'SM_SHOP',
  SM_WEATHER: 'SM_WEATHER',
  SM_IRRIGATE: 'SM_IRRIGATE',
  SM_PATHOGEN: 'SM_PATHOGEN',
  SM_XSENSE: 'SM_XSENSE',
  SM_XNODE: 'SM_XNODE',
  SM_FINANCE: 'SM_FINANCE_PRO',
  SM_EXPORT_FREE: 'SM_EXPORT_FREE',
  SM_ROLES_ACCESS: 'SM_ROLES_ACCESS',
  SM_PESTICIDES_INFO: 'SM_PESTICIDES_INFO',
  SM_SATELLITE_LITE: 'SM_SATELLITE_LITE',
  SM_SATELLITE: 'SM_SATELLITE',
  SM_MULTIFARM_10: 'SM_MULTIFARM_10',
  SM_MULTIFARM_100: 'SM_MULTIFARM_100',
  SM_MULTIFARM_1000: 'SM_MULTIFARM_1000',
  SM_MULTIFARM_10000: 'SM_MULTIFARM_10000',
  SM_MULTIFARM_100000: 'SM_MULTIFARM_100000',
  SM_PRECISIONFARMING: 'SM_PRECISIONFARMING',
  SM_EXPORT_BIO: 'SM_EXPORT_BIO',
  SM_EXPORT_GLOBAL_GAP: 'SM_EXPORT_GLOBAL_GAP',
  SM_EQUIPMENT_TELEMETRY: 'SM_EQUIPMENT_TELEMETRY',
  SM_EDUCATION_EDITOR: 'SM_EDUCATION_EDITOR',
  SM_XBLOG_EDITOR: 'SM_XBLOG_EDITOR',
  SM_OPERATION_MANAGEMENT: 'SM_OPERATION_MANAGEMENT',
  SM_WORK_PLANNING: 'SM_WORK_PLANNING',
  SM_CROP_PLANNING: 'SM_CROP_PLANNING',
  SM_EQUIPMENT_TELEMETRY_AGRIROUTER: 'SM_EQUIPMENT_TELEMETRY_AGRIROUTER',
  SM_EQUIPMENT_TELEMETRY_ALLYNAV: 'SM_EQUIPMENT_TELEMETRY_ALLYNAV',
  SM_EQUIPMENT_TELEMETRY_CLAAS: 'SM_EQUIPMENT_TELEMETRY_CLAAS',
  SM_EQUIPMENT_TELEMETRY_CLAAS_CONNECT: 'SM_EQUIPMENT_TELEMETRY_CLAAS_CONNECT',
  SM_EQUIPMENT_TELEMETRY_CLAAS_CONNECT_PD: 'SM_EQUIPMENT_TELEMETRY_CLAAS_CONNECT_PD',
  SM_EQUIPMENT_TELEMETRY_CLAAS_CONNECT_OFT: 'SM_EQUIPMENT_TELEMETRY_CLAAS_CONNECT_OFT',
  SM_EQUIPMENT_TELEMETRY_COBO_XFARMMASTER: 'SM_EQUIPMENT_TELEMETRY_COBO_XFARMMASTER',
  SM_EQUIPMENT_TELEMETRY_COBO_COBOMASTER: 'SM_EQUIPMENT_TELEMETRY_COBO_COBOMASTER',
  SM_EQUIPMENT_TELEMETRY_TEYME: 'SM_EQUIPMENT_TELEMETRY_TEYME',
  SM_EQUIPMENT_TELEMETRY_YNNOVA: 'SM_EQUIPMENT_TELEMETRY_YNNOVA',
  SM_EQUIPMENT_TELEMETRY_NON_ARAG_YNNOVA: 'SM_EQUIPMENT_TELEMETRY_NON_ARAG_YNNOVA',
  SM_EQUIPMENT_TELEMETRY_SDFBTM: 'SM_EQUIPMENT_TELEMETRY_SDFBTM',
  SM_EQUIPMENT_TELEMETRY_SDFCTM: 'SM_EQUIPMENT_TELEMETRY_SDFCTM',
  SM_EQUIPMENT_TELEMETRY_GEOTAB: 'SM_EQUIPMENT_TELEMETRY_GEOTAB',
  SM_EQUIPMENT_TELEMETRY_CNH_PREMIUM: 'SM_EQUIPMENT_TELEMETRY_CNH_PREMIUM',
  SM_EQUIPMENT_TELEMETRY_CNH_BLUE_PREMIUM: 'SM_EQUIPMENT_TELEMETRY_CNH_BLUE_PREMIUM',
  SM_EQUIPMENT_TELEMETRY_AMASLIMT4: 'SM_EQUIPMENT_TELEMETRY_AMASLIMT4',
  SM_EQUIPMENT_TELEMETRY_SMART2: 'SM_EQUIPMENT_TELEMETRY_SMART2',
  SM_EQUIPMENT_TELEMETRY_WAY: 'SM_EQUIPMENT_TELEMETRY_WAY',
  SM_EQUIPMENT_TELEMETRY_GOLDONI: 'SM_EQUIPMENT_TELEMETRY_GOLDONI',
  SM_EQUIPMENT_TELEMETRY_MATERMACC: 'SM_EQUIPMENT_TELEMETRY_MATERMACC',
  SM_EQUIPMENT_TELEMETRY_CLIMATE_FIELDVIEW: 'SM_EQUIPMENT_TELEMETRY_CLIMATE_FIELDVIEW',
  SM_EQUIPMENT_TELEMETRY_JOHN_DEERE: 'SM_EQUIPMENT_TELEMETRY_JOHN_DEERE',
  SM_EQUIPMENT_TELEMETRY_TRAKMATE: 'SM_EQUIPMENT_TELEMETRY_TRAKMATE',
  SM_ANALYTICS_CHAIN_MANAGEMENT: 'SM_ANALYTICS_CHAIN_MANAGEMENT',
  SM_SUSTAINABILITY: 'SM_SUSTAINABILITY',
  SM_IMPACT: 'SM_IMPACT',
  SM_REGENERATIVE: 'SM_REGENERATIVE',
  SM_ANALYTICS_SUSTAINABILITY: 'SM_ANALYTICS_SUSTAINABILITY',
  SM_ANALYTICS_OVERVIEW: 'SM_ANALYTICS_OVERVIEW',
  SM_INCABCLOUD_TELEMETRY: 'SM_INCABCLOUD_TELEMETRY',
  SM_INCAB_TELEMETRY: 'SM_INCAB_TELEMETRY',
  SM_MULTIFARM_FREE: 'SM_MULTIFARM_FREE',
  SM_STABLE: 'SM_STABLE',
  SM_ANIMAL: 'SM_ANIMAL',
  SM_STABLEACTIVITY: 'SM_STABLEACTIVITY',
  SM_INSECTS: 'SM_INSECTS',
  SM_EQUIPMENT_TELEMETRY_PFN: 'SM_EQUIPMENT_TELEMETRY_PFN',
  SM_FARM_DOSSIER: 'SM_FARM_DOSSIER',
  SM_EQUIPMENT_TEMPLATE_PFN: 'SM_EQUIPMENT_TEMPLATE_PFN',
  SM_CONNECTION_PARMALAT: 'SM_CONNECTION_PARMALAT',
  SM_STABLE_LOAD: 'SM_STABLE_LOAD',
  SM_CONTRACT_MANAGEMENT: 'SM_CONTRACT_MANAGEMENT',
  SM_CONTRACT_AUDIT: 'SM_CONTRACT_AUDIT',
  SM_CONNECTION_CASTELLI: 'SM_CONNECTION_CASTELLI',
  SM_CONNECTION_GRANLATTE: 'SM_CONNECTION_GRANLATTE',
  SM_CHECKS: 'SM_CHECKS',
  SM_RULE_CHECK: 'SM_RULE_CHECK',
  SM_RATIONS: 'SM_RATION_PRO',
  SM_PATHOGEN_AGROSAT: 'SM_PATHOGEN_AGROSAT',
  SM_EQUIPMENT_TELEMETRY_CNHMAP: 'SM_EQUIPMENT_TELEMETRY_CNHMAP',
  SM_CROP_MAP: 'SM_CROP_MAP',
  SM_SURVEY: 'SM_SURVEY',
  SM_CONNECTION_GALBANI: 'SM_CONNECTION_GALBANI',
  SM_NUTRITION_FREE: 'SM_NUTRITION_FREE',
  SM_NUTRITION_LITE: 'SM_NUTRITION_LITE',
  SM_NUTRITION: 'SM_NUTRITION',
  SM_NUTRITION_AGROSAT: 'SM_NUTRITION_AGROSAT',
  SM_NUTRITION_YARA: 'SM_NUTRITION_YARA',
  SM_PRODUCT_YARA: 'SM_PRODUCT_YARA',
  SM_ANALYTICS_REGENERATIVE: 'SM_ANALYTICS_REGENERATIVE',
  SM_ANALYTICS_IMPACT: 'SM_ANALYTICS_IMPACT',
  SM_CONNECTION_AMBROSI: 'SM_CONNECTION_AMBROSI',
  SM_CONNECT_CFT_CHAINMANAGER: 'SM_CONNECT_CFT_CHAINMANAGER',
  SM_CONNECT_CFT_BASICUSER: 'SM_CONNECT_CFT_BASICUSER',
  SM_CONNECT_CONNECTERRA_CONNECTION: 'SM_CONNECT_CONNECTERRA_CONNECTION',
  SM_IRRIGATION: 'SM_IRRIGATION',
  SM_IRRIGATION_FIELD_FREE: 'SM_IRRIGATION_FIELD_FREE',
  SM_IRRIGATION_FIELD_PRO: 'SM_IRRIGATION_FIELD_PRO',
};
